// The pixel game (app/game) lives at its own address; the site's menu links there.
export const GAME_HOST = "game.sweet.xxx";
export const GAME_URL = `https://${GAME_HOST}/`;

/**
 * The game's own pages for one kind of play (app/game/[lang]/[theme]): it opens set up for it (gay, lesbian or
 * trans couples in the house, the red room, a threesome to pick), with its own page under it.
 */
export const GAME_THEMES = ["gay", "lesbian", "trans", "bdsm", "threesome", "earn"] as const;
export type GameTheme = (typeof GAME_THEMES)[number];
export const isGameTheme = (v: unknown): v is GameTheme => typeof v === "string" && (GAME_THEMES as readonly string[]).includes(v);

const gameSegments = (lang: string, theme?: GameTheme) => [lang === "en" ? "" : lang, theme ?? ""].filter(Boolean).join("/");

/** The game in a language: English at the address itself, the others under it (/de, /ru …; next.config.ts), a theme after it (/gay, /de/gay). */
export const gameUrl = (lang: string, theme?: GameTheme) => `${GAME_URL}${gameSegments(lang, theme)}`;

/** The same as a path on the game's own address, or under /game anywhere else (development). */
export const gamePath = (lang: string, onGameHost: boolean, theme?: GameTheme) => (onGameHost ? `/${gameSegments(lang, theme)}` : `/game/${lang}${theme ? `/${theme}` : ""}`);

/** The game's videos (app/game-videos): their list at /videos and each at /videos/<slug>, in each language (/de/videos …). */
/** The page about the game (what it is, the trailer, the FAQ…), apart from the game itself: /about, /de/about … */
export const gameAboutUrl = (lang: string) => `${GAME_URL}${[lang === "en" ? "" : lang, "about"].filter(Boolean).join("/")}`;
export const gameVideosUrl = (lang: string, slug?: string) => `${GAME_URL}${[lang === "en" ? "" : lang, "videos", slug ?? ""].filter(Boolean).join("/")}`;
